import { jsx as _jsx } from "react/jsx-runtime";
import { AiAdoptionAndUsageIcon } from '@web/components/ui/icons/PerformanceReviewSections/AiAdoptionAndUsageIcon';
import { CommunicationIcon } from '@web/components/ui/icons/PerformanceReviewSections/CommunicationIcon';
import { DailyTimelineIcon } from '@web/components/ui/icons/PerformanceReviewSections/DailyTimelineIcon';
import { InitiativeAndOwnershipIcon } from '@web/components/ui/icons/PerformanceReviewSections/InitiativeAndOwnershipIcon';
import { OverviewIcon } from '@web/components/ui/icons/PerformanceReviewSections/OverviewIcon';
import { PolicyComplianceIcon } from '@web/components/ui/icons/PerformanceReviewSections/PolicyComplianceIcon';
import { ScheduleAndAttendanceIcon } from '@web/components/ui/icons/PerformanceReviewSections/ScheduleAndAttendanceIcon';
import { TimeManagementIcon } from '@web/components/ui/icons/PerformanceReviewSections/TimeManagementIcon';
import { WorkLifeBalanceIcon } from '@web/components/ui/icons/PerformanceReviewSections/WorkLifeBalanceIcon';
import { PerformanceReviewSectionsEnum } from '@workalizer/shared';
export var PerformanceReviewSectionIcon = function (_a) {
    var section = _a.section, _b = _a.className, className = _b === void 0 ? 'w-5 h-5 inline-block' : _b;
    switch (section) {
        case PerformanceReviewSectionsEnum.OVERVIEW:
            return _jsx(OverviewIcon, { className: className });
        case PerformanceReviewSectionsEnum.COMMUNICATION:
            return _jsx(CommunicationIcon, { className: className });
        case PerformanceReviewSectionsEnum.INITIATIVE_AND_OWNERSHIP:
            return _jsx(InitiativeAndOwnershipIcon, { className: className });
        case PerformanceReviewSectionsEnum.SCHEDULE_AND_ATTENDANCE:
            return _jsx(ScheduleAndAttendanceIcon, { className: className });
        case PerformanceReviewSectionsEnum.TIME_MANAGEMENT:
            return _jsx(TimeManagementIcon, { className: className });
        case PerformanceReviewSectionsEnum.WORK_LIFE_BALANCE:
            return _jsx(WorkLifeBalanceIcon, { className: className });
        case PerformanceReviewSectionsEnum.POLICY_COMPLIANCE:
            return _jsx(PolicyComplianceIcon, { className: className });
        case PerformanceReviewSectionsEnum.AI_ADOPTION_AND_USAGE:
            return _jsx(AiAdoptionAndUsageIcon, { className: className });
        case PerformanceReviewSectionsEnum.DAILY_TIMELINE:
            return _jsx(DailyTimelineIcon, { className: className });
        default:
            return null;
    }
};
